/*
 * @Author: suJiuFu 15070021572@jq.com
 * @Date: 2024-10-22 17:18:12
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-05-28 16:36:11
 * @FilePath: \bwhb-admin\src\router\index.js
 * @Description: 路由入口
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') this.replace('/404')
  })
}

Vue.use(VueRouter)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
let routes = [
  {
    path: '/',
    redirect: '/home'
  }
]
Object.values(modules).forEach(moduleList => {
  routes = routes.concat(moduleList)
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = '如是佛典-高僧传知识图谱' + (to.meta.title ? '-' + to.meta.title : '')
  if (Object.keys(store.state.dict).length === 0) {
    await store.dispatch('getPersonCategory')
    await store.dispatch('getBiographieName')
    await store.dispatch('getAllSect')
    await store.dispatch('getAllDynasty')
  }
  next()
})

export default router
